import { render, staticRenderFns } from "./vehicleassets.html?vue&type=template&id=2c080107&scoped=true&"
import script from "./vehicleassets.vue?vue&type=script&lang=js&"
export * from "./vehicleassets.vue?vue&type=script&lang=js&"
import style0 from "./vehicleassets.vue?vue&type=style&index=0&id=2c080107&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c080107",
  null
  
)

export default component.exports